import { render, staticRenderFns } from "./CallMeNowComponent.vue?vue&type=template&id=14e573e8"
import script from "./CallMeNowComponent.vue?vue&type=script&lang=ts"
export * from "./CallMeNowComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports